/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import MKTypography from "../../../../components/MKTypography";
import Grid2 from "@mui/material/Grid2";

function Information() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <Grid2 container spacing={3} alignItems="center" justifyContent="center">
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <MKTypography variant="h4" color="info" mt={1} mb={3} textAlign="center" fontWeight="regular">
              ABOUT
            </MKTypography>
            <MKTypography
                variant="h3"
                color="dark"
                textAlign="center"
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["lg"],
                  },
                })}
            >
              "고객의 성공이 우리의 지향점, <br/>신뢰와 협력으로 최고의 파트너십을 구축합니다."
            </MKTypography>
            <MKTypography variant="h5" color="dark" mt={3} mb={1} textAlign="center" fontWeight="regular">
              고객의 성공을 최우선으로,
            </MKTypography>
            <MKTypography variant="h5" color="dark" mt={3} mb={1} textAlign="center" fontWeight="regular">
              맞춤형 지원과 긴밀한 협력으로 신뢰를 쌓아 최고의 파트너십을 구축하고,<br/>
            </MKTypography>
            <MKTypography variant="h5" color="dark" mt={3} mb={1} textAlign="center" fontWeight="regular">
              끊임없는 혁신으로 고객의 장기적 성공을 견인합니다.
            </MKTypography>
          </Grid2>
        </Grid2>
      </Container>
    </MKBox>
  );
}

export default Information;
